
import { types } from './../types/types';


const initialState={
    projects:[]
}

export const projectsReducer=(state=initialState,action)=>{
    switch (action.type) {
        case types.projectsLoaded:
            return {
                ...state,
                projects:[...action.payload]
            }
      
        default:
            return state;
    }
}